import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import "../components/Shop/Shop.css"
import Tabs from "../components/Shop/Tabs/Tabs"
import Colors from "../components/Shop/Colors/Color"
import Phone from "../components/Shop/Devices/Phone"
import Catagory from "../components/Shop/Filter/Catagorys"
import ColourInput from "../components/Shop/Filter/ColourInput"
import Filter from "../components/Shop/Filter/Filter"
import Input from "../components/Shop/Filter/Input"
import Storage from "../components/Shop/Stoarge/Storage"
import TopPick from "../components/Shop/TopPicks/TopPick"
import MiniSlots from "../components/Shop/TopPicks/MiniSlots"
import MiniSlot from "../components/Shop/TopPicks/MiniSlot"
import Accessory from "../components/Shop/Devices/Accessory"

const IndexPage = () => (
  <Layout>
    <Seo title="Shop" />
    <Tabs>
      <div label="Devices">
        <div className="Shop-Grid">
          <Filter
            filterTitle="Filter by"
            total="56"
            catagorys={
              <div className="Catagorys">
                <Catagory
                  catagory="Brand"
                  filter={
                    <div className="Input">
                      <Input filter="Apple" />
                      <Input filter="Samsung" />
                      <Input filter="Alacatel" />
                      <Input filter="Sony" />
                      <Input filter="Huwaie" />
                      <Input filter="LG" />
                      <Input filter="Mobiwire" />
                      <Input filter="Motorola" />
                      <Input filter="Verve Connect" />
                    </div>
                  }
                />
                <Catagory
                  catagory="Speed"
                  filter={
                    <div className="Input">
                      <Input filter="5G" />
                      <Input filter="4G" />
                      <Input filter="3G" />
                    </div>
                  }
                />
                <Catagory
                  catagory="Capacity"
                  filter={
                    <div className="Input">
                      <Input filter="512 GB" />
                      <Input filter="128 GB" />
                      <Input filter="64 GB" />
                      <Input filter="32 GB" />
                    </div>
                  }
                />
                <Catagory
                  catagory="Operating system"
                  filter={
                    <div className="Input">
                      <Input filter="iOS" />
                      <Input filter="Andriod" />
                      <Input filter="Windows" />
                    </div>
                  }
                />
                <Catagory
                  catagory="Colour"
                  filter={
                    <div className="color-grid">
                      <ColourInput color="red" />
                      <ColourInput color="black" />
                      <ColourInput color="blue" />
                      <ColourInput color="gray" />
                      <ColourInput color="violet" />
                      <ColourInput color="pink" />
                    </div>
                  }
                />
              </div>
            }
          />
          <ul className="Device-Group">
            <Phone
              phone="Samsung Galaxy 21 Ultra"
              manufacture="Samsung"
              model="Galaxy 21 Ultra"
              modelname="S21Ultra"
              product="https://shop.ee.co.uk/medias/samsung-galaxy-s21-ultra-silver-no-gwp-front-gallery-Format-237?context=bWFzdGVyfHJvb3R8MTQxMzh8aW1hZ2UvanBlZ3xzeXMtbWFzdGVyL3Jvb3QvaDkzL2hmYy85NjIyMzk1NTg0NTQyL3NhbXN1bmctZ2FsYXh5LXMyMS11bHRyYS1zaWx2ZXItbm8tZ3dwLWZyb250LWdhbGxlcnlfRm9ybWF0LTIzN3xkNjhhYzM3NWUxZDZiYmVkYWQ3NzYzOWNkOGU2NGM2MzQzMTc0NTIyMTdhOTM2NTQ2NDc5ZTQ5OWJjODlhMWNh"
              color1={<Colors color="red" />}
              color2={<Colors color="brown" />}
              color3={<Colors color="gray" />}
              storage1={<Storage capacity="128" />}
              storage2={<Storage capacity="256" />}
              price="1,199"
            />
            <Phone
              phone="Samsung Galaxy 21+"
              manufacture="Samsung"
              model="Galaxy 21+"
              modelname="S21Plus"
              product="https://shop.ee.co.uk/medias/samsung-galaxy-s21-plus-violet-no-gwp-front-primary-Format-237?context=bWFzdGVyfHJvb3R8MTIzMTh8aW1hZ2UvanBlZ3xzeXMtbWFzdGVyL3Jvb3QvaDQxL2hjZC85NjIyNDAwNTk4MDQ2L3NhbXN1bmctZ2FsYXh5LXMyMS1wbHVzLXZpb2xldC1uby1nd3AtZnJvbnQtcHJpbWFyeV9Gb3JtYXQtMjM3fDgwZmY5MGRlZWQ4ZGQ3ODlmMDRjY2ZkMmI0NGExZTU1ZDA4Mzk1MjY3MmNhMjY5N2VlMWJkNWY1ZGVlOWVjNWU"
              color1={<Colors color="violet" />}
              color2={<Colors color="black" />}
              color3={<Colors color="silver" />}
              storage1={<Storage capacity="128" />}
              storage2={<Storage capacity="256" />}
              price="999"
            />
            <Phone
              phone="Samsung Galaxy 21"
              manufacture="Samsung"
              model="Galaxy 21"
              modelname="S21"
              product="https://shop.ee.co.uk/content/dam/everything-everywhere/asset-migration/S21_PhantomWhite_Front_960x540.png.eeimg.480.1-1.default.png"
              color1={<Colors color="violet" />}
              color2={<Colors color="gray" />}
              color3={<Colors color="white" />}
              color4={<Colors color="pink" />}
              storage1={<Storage capacity="128" />}
              storage2={<Storage capacity="256" />}
              price="819"
            />
            <Phone
              phone="Pixel 5"
              manufacture="Google"
              model="Pixel 5"
              modelname="Pixel5"
              product="https://shop.ee.co.uk/medias/google-pixel-5-black-gwp-gallery-Format-237?context=bWFzdGVyfHJvb3R8MzI0Njd8aW1hZ2UvanBlZ3xzeXMtbWFzdGVyL3Jvb3QvaGQ0L2g5ZC85NTUwNDk0NjYyNjg2L2dvb2dsZS1waXhlbC01LWJsYWNrLWd3cC1nYWxsZXJ5X0Zvcm1hdC0yMzd8YzJlZjNlZWI3YjgwZmJjZWRhYWNiMTQwZmVhMjNiNDU5ZDgzZDgxMWVjOWIwZDY0Y2JmZjA1ZmQ2OTI3ZDM0Yg"
              color1={<Colors color="black" />}
              storage1={<Storage capacity="128" />}
              price="599"
            />
            <Phone
              manufacture="Sony"
              model="Xperia 10 III"
              modelname="X10III"
              product="https://asset1.ee.co.uk/medias/sony-xperia-10-III-5g-black-desktop-detail-2-Format-976?context=bWFzdGVyfHJvb3R8NTMwMTIxfGltYWdlL3BuZ3xzeXMtbWFzdGVyL3Jvb3QvaDZlL2g3Ni85NjY4MTc2MTgzMzI2L3NvbnkteHBlcmlhLTEwLUlJSS01Zy1ibGFjay1kZXNrdG9wLWRldGFpbC0yX0Zvcm1hdC05NzZ8MTBlYjZlNTVlZmRjYWM5YTc3ZGZkOWJhY2QyNzRmYWNhMTg2MDIwMWY0NmYzMjQ3ZGE0MTAyNTdiZWE2MjVhOQ"
              color1={<Colors color="black" />}
              storage1={<Storage capacity="128" />}
              price="319"
            />
          </ul>
        </div>
      </div>
      <div label="Accessories">
        <div className="Shop-Grid">
          <Filter
            filterTitle="Filter Accessories"
            total="56"
            catagorys={
              <div className="Catagorys">
                <Catagory
                  catagory="Brand"
                  filter={
                    <div className="Input">
                      <Input filter="Apple"/>
                      <Input filter="Samsung" />
                      <Input filter="Alacatel" />
                      <Input filter="Sony"/>
                      <Input filter="Huwaie" />
                      <Input filter="LG" />
                      <Input filter="Mobiwire" />
                      <Input filter="Motorola" />
                      <Input filter="Verve Connect" />
                    </div>
                  }
                />
                <Catagory
                  catagory="Colour"
                  filter={
                    <div className="color-grid">
                      <ColourInput color="red" />
                      <ColourInput color="black" />
                      <ColourInput color="blue" />
                      <ColourInput color="gray" />
                      <ColourInput color="violet" />
                      <ColourInput color="pink" />
                    </div>
                  }
                />
              </div>
            }
          />
          <ul className="Device-Group">
            <Accessory
              manufacture="Samsung"
              accessory="Type C Cable"
              modelname=""
              product="https://fl-assets.exertis.co.uk/product/8806088571447-1/5e807c79336fd/300x300.jpg"
              color1={<Colors color="darkgray" />}
              color2={<Colors color="gray" />}
              price="14.99"
            />
            <Accessory
              manufacture="Samsung"
              accessory="Wireless Quick Charger"
              modelname=""
              color1={<Colors color="darkgray" />}
              color2={<Colors color="gray" />}
              product="https://fl-assets.exertis.co.uk/product/8801643118716-1/5e735fd116365/300x300.jpg"
              price="69.99"
            />
            <Accessory
              manufacture="Samsung"
              accessory="fast mains charger"
              modelname=""
              color1={<Colors color="darkgray" />}
              color2={<Colors color="gray" />}
              product="https://images.samsung.com/is/image/samsung/p6pim/uk/ep-ta800nweggb/gallery/uk-wall-charger-for-super-fast-charging-25w-ep-ta800nweggb-376741508?$684_547_PNG$"
              price="14.99"
            />
            <Accessory
              manufacture="Samsung"
              accessory="Dex Station"
              modelname=""
              color1={<Colors color="darkgray" />}
              color2={<Colors color="gray" />}
              product="https://images.samsung.com/is/image/samsung/uk-dex-station-mg950-ee-mg950bbegww-rslideopenblack-61740737?$684_547_PNG$"
              price="116.99"
            />
          </ul>
        </div>
      </div>
      <div label="Top Picks">
        <div className="About-Top">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna, ipsum dolor sit
            amet, consectetur adipiscing elit, sed do eiusmo.
          </p>
        </div>
        <div className="Big-Grid">
          <TopPick
            title="Galaxy S21 Series 5G"
            items={
              <ul className="TopPick-Items">
                <li>Top Samsung Enterpise range on offer this month</li>
                <li>Exclusive to online orders only</li>
              </ul>
            }
            img="../images/banners/S21Ultra.png"
            banner="SamsungTopPick"
          />
          <MiniSlots
            slot1={<MiniSlot title="Slot 2" />}
            slot2={<MiniSlot title="Slot 3" />}
            slot3={<MiniSlot title="Slot 4" />}
            slot4={<MiniSlot title="Slot 5" />}
          />
          <TopPick
            title="This months tablet deals"
            items={<p>Lorem ipsum dolor sit amet, coum dolor sit ame.</p>}
            img="../images/banners/SamsungTablet.png"
            banner="TabletTopPick"
          />
          <TopPick
            title="This months Accessories deals"
            items={<p>Lorem ipsum dolor sit amet, coum dolor sit ame.</p>}
            img="../images/banners/Accessories.png"
            banner="AcessoryTopPick"
          />
        </div>
      </div>
    </Tabs>
  </Layout>
)

export default IndexPage
